export const MODULES = {
    STUDENT_PROFILE: 'STUDENT_PROFILE',
    CLASS_SCHEDULE: 'CLASS_SCHEDULE',
    FEES: 'FEES',
    NOTIFICATIONS: 'NOTIFICATIONS',
    DOCUMENTS: 'DOCUMENTS',
    STUDENT_PERFORMANCE: 'STUDENT_PERFORMANCE',
    ATTENDANCE: 'ATTENDANCE',
    EXAMINATION: 'EXAMINATION',
    COURSE_MANAGEMENT: 'COURSE_MANAGEMENT',
    USER_MANAGEMENT: 'USER_MANAGEMENT',
    ROLE_MANAGEMENT: 'ROLE_MANAGEMENT',
    SYSTEM_SETTINGS: 'SYSTEM_SETTINGS'
  };
  
  export const ACTIONS = {
    VIEW: 'VIEW',
    CREATE: 'CREATE',
    EDIT: 'EDIT',
    DELETE: 'DELETE',
    APPROVE: 'APPROVE',
    REJECT: 'REJECT',
    DOWNLOAD: 'DOWNLOAD',
    UPLOAD: 'UPLOAD',
    PRINT: 'PRINT'
  };
  
  export default {
    MODULES,
    ACTIONS
  };